import { create } from "zustand";
import lifeforce from "../backend/lifeforce";

export type Role = "user" | "assistant" | "system" | "tool" | "artifact";

export type Message = {
  role: Role;
  content: string;
};

export type Artifact = {
  id: string;
  title: string;
  kind: "text" | "document" | "code" | "other";
  url?: string;
  description?: string;
  content?: string; // optional; not rendered in UI
  createdAt: number;
};

type ChatState = {
  user: { id: string; email?: string } | null;
  session: any;
  messages: Message[];
  artifacts: Artifact[];
  setUser: (u: ChatState["user"]) => void;
  setSession: (s: ChatState["session"]) => void;
  sendUserMessage: (content: string) => Promise<void>;
  setHistory: (messages: Message[]) => void;
  receiveServerSideEvent: (event: any) => void;
};

export const useChatStore = create<ChatState>((set, get) => ({
  user: null,
  messages: [],
  artifacts: [],
  session: null,
  setUser: (u) => set({ user: u }),
  setSession: (s) => set({ session: s }),
  sendUserMessage: async (content: string) => {
    lifeforce.event({
      __type: "user-msg",
      value: content,
    });

    set({ messages: [...get().messages, { role: "user", content }] });
  },
  receiveServerSideEvent: (event: any) => {
    console.log("Received server-sent event:", event);
    if (!event || !event.__type) {
      console.warn("Invalid event format:", event);
      return;
    }

    if (event.__type === "assistant-msg") {
      const content = event.value;
      set({ messages: [...get().messages, { role: "assistant", content }] });
      return;
    }

    console.warn(
      "Unknown event type:",
      event.__type,
      "with value:",
      event.value
    );
  },
  setHistory: (messages: Message[]) => set({ messages }),
}));
